module.exports = __webpack_public_path__ + "img/floor_type23.85484ccc.png";